import { ApolloClient } from '@apollo/client';

import { createApolloSanityClient } from '../../pages/homepage/apolloSanityClient';

export const sanityClient: ApolloClient<any> = createApolloSanityClient(window.ozSanityConfig);
